import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../store/api/rx-factory'
import * as Enpoints from '../../../../store/api/endpoints'
import * as COMMON from '../../../../store/commomFunction'
import moment from 'moment'
export const actions = {
    // ================= WATCH LIST ================================
    [Const.RUN_GET_NEWS_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_NEWS_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if(credentials.globalParams.tags){
                    commit(Const.SET_CRYPTO_NEWS_LIST, result.res_data)
                }else{
                    commit(Const.SET_NEWS_LIST, result.res_data)
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================= WATCH LIST ================================
    [Const.RUN_GET_WATCH_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WATCH_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_WATCH_LIST, result.res_data)
                result.res_data.forEach((val, index) => {
                    if (val._id === null) {
                        credentials.localParams.parameter.subscribPairs(result.res_data[index].subscribe)
                    }
                })
                /*result.res_data.forEach((val,index)=>{
                    if(val._id === credentials.localParams.parameter.watchId){
                        idFound = true
                        credentials.localParams.parameter.fevList = (val.is_fav)?val.is_fav:[]
                        credentials.localParams.parameter.setWatch(val)
                    }
                    if(index == result.res_data.length-1 && !idFound){
                        credentials.localParams.parameter.setWatch(result.res_data[0])
                    }
                })*/
            } else {
                commit(Const.SET_WATCH_LIST, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_CONFIRM_WALLET_TRANSACTION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CONFIRM_WALLET_TRANSACTION, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.successTransfer = true
                setInterval(() => {
                    if (credentials.localParams.parameter.redirectIn != 0) {
                        credentials.localParams.parameter.redirectIn -= 1
                    }
                    if (credentials.localParams.parameter.redirectIn == 0) {
                        // credentials.localParams.parameter.logout()
                        localStorage.clear();
                        window.open(result.res_data.return_url, '_self');
                    }
                }, 1000)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_WALLET_MARGIN]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WALLET_MARGIN, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.marginData = result.res_data
                credentials.localParams.parameter.afterGetMargin();
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_API_KEYS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_API_KEYS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data[0].apiKey) {
                    credentials.localParams.parameter.client_secret_key = result.res_data[0].clientSecretKey
                    credentials.localParams.parameter.api_key = result.res_data[0].apiKey
                } else {
                    credentials.localParams.parameter.client_secret_key = result.res_data[0].webhook_label
                    credentials.localParams.parameter.api_key = result.res_data[0].webhook_url
                }

                credentials.localParams.parameter.clear()
            } else {
                credentials.localParams.parameter.clear()
                credentials.localParams.parameter.client_secret_key = ''
                credentials.localParams.parameter.api_key = ''
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_UPDATE_API_KEYS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_UPDATE_API_KEYS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data[0].apiKey) {
                    credentials.localParams.parameter.client_secret_key = result.res_data[0].clientSecretKey
                    credentials.localParams.parameter.api_key = result.res_data[0].apiKey
                }
                credentials.localParams.parameter.clear()
                let user_json = getters[types.GET_USER]
                user_json.api_status = 1
                commit(types.SET_STATE, user_json)

                var user = localStorage.getItem('user')
                user = atob(user);
                user = JSON.parse(user)
                user.api_status = 1
                localStorage.setItem('user', btoa(JSON.stringify(user)))
            } else {
                credentials.localParams.parameter.client_secret_key = ''
                credentials.localParams.parameter.api_key = ''
                credentials.localParams.parameter.clear()
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_UPDATE_API_WEBOOK]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_UPDATE_API_WEBOOK, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.clear()
                credentials.localParams.parameter.$parent.generateApiKey()
            } else {
                credentials.localParams.parameter.clear()
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_NOTIFICATION_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_NOTIFICATION_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if(credentials.globalParams.read == "0"){
					commit(Const.SET_UNREAD_NOTIFICATION_DATA, result.res_data)
				} else if (credentials.globalParams.read == "1"){
					commit(Const.SET_NOTIFICATION_LIST, result.res_data)
				} else {
					commit(Const.SET_NOTIFICATION_LIST, result.res_data)
				}

                // if (credentials.globalParams.read != undefined && !credentials.globalParams.read) {
                //     commit(Const.SET_UNREAD_NOTIFICATION_DATA, result.res_data)
                // } else {
                //     commit(Const.SET_NOTIFICATION_LIST, result.res_data)
                    // let inputJson = {
                    //     'globalParams': {
                    //         'read': "0"
                    //     },
                    //     'localParams': { 'parameter': credentials.localParams.parameter }
                    // }
                    // dispatch(Const.RUN_GET_NOTIFICATION_LIST, inputJson);
                // }
                // commit(Const.SET_NOTIFICATION_LIST, result.res_data)
            } else {
                //commit(Const.SET_NOTIFICATION_LIST, result.res_data)
                
                // if (credentials.globalParams.read != undefined && !credentials.globalParams.read) {
                //     commit(Const.SET_UNREAD_NOTIFICATION_DATA, [])
                // } else {
                //     commit(Const.SET_NOTIFICATION_LIST, [])
                // }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_READ_UNREAD_NOTIFICATION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_READ_UNREAD_NOTIFICATION, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.afterUnread()
                // commit(Const.SET_NOTIFICATION_LIST, [])
            } else {
                // commit(Const.SET_NOTIFICATION_LIST, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    [Const.RUN_NOTIFICATION_SETTINGS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_NOTIFICATION_SETTINGS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter,'Enable Notification Successfully', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    [Const.RUN_NOTIFICATION_GET_SETTINGS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_NOTIFICATION_GET_SETTINGS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_NOTIFICATION_GET_SETTINGS, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    [Const.RUN_NOTIFICATION_ENABLE_GET_SETTINGS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_NOTIFICATION_ENABLE_GET_SETTINGS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const data = getters[Const.GET_NOTIFICATION_GET_SETTINGS]
                commit(Const.SET_NOTIFICATION_ENABLE_GET_SETTINGS, result.res_data)
                if(result.res_data.length > 0){
                    if(data.length){
                        data.forEach(val =>{
                            result.res_data.forEach(item =>{
                                if(item.id == val.id){
                                    credentials.localParams.parameter.notification_vmodel[item.id] = 1
                                }
                            })
                        })
                    }else{
                        result.res_data.forEach(item =>{
                            credentials.localParams.parameter.notification_vmodel[item.id] = 0
                        })
                    }
                  }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    [Const.RUN_GET_PAYMENT_METHODS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PAYMENT_METHODS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PAYMENT_METHODS, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_PROFILE_INFO]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PROFILE_INFO, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PROFILE_INFO, result.res_data[0])
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GENERATE_2FA_QRCODE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials, '', commit, (error, result) => {
            if (!error) {
                if(typeof(result.res_data) == "object"){
                    credentials.localParams.parameter.src_data = result.res_data.data
                }else{
                    credentials.localParams.parameter.src_data = result.res_data
                }
            } else {
                /*if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
                    credentials.localParams.parameter.$parent.authComponent = true
                }*/
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_VERIFY_2FA_QRCODE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials, '', commit, (error, result) => {
            if (!error) {
                let user_json = getters[types.GET_USER]
                user_json.profile.gAuthenticatorEnabled = 1
                user_json.fresh_user = 1
                commit(types.SET_STATE, user_json)

                var user = localStorage.getItem('user')
                user = atob(user);
                user = JSON.parse(user)
                user.profile.gAuthenticatorEnabled = 1
                user.fresh_user = 1
                localStorage.setItem('user', btoa(JSON.stringify(user)))

                credentials.localParams.parameter.div_show = ''
                credentials.localParams.parameter.otp = ''
                credentials.localParams.parameter.getBack()
                COMMON._messageDisplayFunction(credentials.localParams.parameter, '2FA Enabled successfully', 'success')
                if(parseInt(user_json.step) < 3){
                    // console.log("register action file step 2-==================>")
                    let type = parseInt(user_json.lead_type) == 1?'corporate':'individual'
                    credentials.localParams.parameter.$router.replace('/'+type+'-step'+(parseInt(user_json.step)+1))
                }else if (credentials.localParams.call_from == 'api_key') {
                    credentials.localParams.parameter.$parent.div_section = 2
                } else if (credentials.localParams.call_from == 'twoFaAfterRegisteration') {
                    // console.log("register action file step 1-==================>")
                    if(parseInt(user_json.step) < 3){
                        console.log("register action file step 2-==================>")
                        credentials.localParams.parameter.$router.replace('/individual-step'+(parseInt(user_json.step)+1))
                    }else{
                        // console.log("register action file step 3-==================>")
                        credentials.localParams.parameter.$router.replace('/welcome')
                    }
                } else if (credentials.localParams.call_from == 'twoFaAfterLogin') {
                    credentials.localParams.parameter.$parent.submitCode(credentials.globalParams.google_token)
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')

            }
        })
    },
    /*[Const.RUN_DISABLE_2FA_QRCODE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.DisableOtp = ''
                credentials.localParams.parameter.div_show = ''
                credentials.localParams.parameter.generateQrCode()

                let user_json = getters[types.GET_USER]
                user_json.profile.gAuthenticatorEnabled = 0
                commit(types.SET_STATE, user_json)
                var user = localStorage.getItem('user')
                user = atob(user);
                user = JSON.parse(user)
                user.profile.gAuthenticatorEnabled = 0
                localStorage.setItem('user', btoa(JSON.stringify(user)))

                COMMON._messageDisplayFunction(credentials.localParams.parameter, '2FA Disabled successfully', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },*/
    [Const.RUN_DISABLE_2FA_QRCODE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.closeModal('gauthModal')
                dispatch(types.RUN_LOGOUT, { globalParams: {}, localParams: { parameter: this } })
            } else {
                // console.log("=============+>",result.code)
                if(result.code && result.code == 'INVALID_OTP'){
                    credentials.localParams.parameter.error = true
                    credentials.localParams.parameter.passwordError = 'Invalid Password'
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_CRYPTO_ADDRESSES]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_CRYPTO_ADDRESSES, credentials, '', commit, (error, result) => {
            if (!error) {
                commit(Const.SET_CRYPTO_ADDRESSES, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_BANK_ADDRESSES]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_BANK_ADDRESSES, credentials, '', commit, (error, result) => {
            if (!error) {
                commit(Const.SET_BANK_ADDRESSES, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
}
/*
function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            callback(false, response_array)
                        } else {
                            if (typeof data.msg == 'object') {
                                response_array.res_data = data.msg.msg
                            } else {
                                response_array.res_data = data.msg
                            }
                            callback(true, response_array)
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}

function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}*/


// WEBPACK FOOTER //
// ./src/plugins/commonAll/provider/store-addons/actions.js